import React from 'react';

import GenericCardRenderItems from './GenericCardRenderItems';

const ComplementoPlataformasTecnologicasBaseResumen = ({ data = {} }) => {
  return (
    <div className="d-block mt-2 mb-2">
      <GenericCardRenderItems
        data={data}
        width={200}
        labels={labels(data)}
      />
    </div>
  );
};

const labels = (data = {}) => {
  return [
    {
      label: 'Diferencia servicio prestado con el iva entregado',
      index: 'DifIVAEntregadoPrestServ',
    },
    {
      label: 'Monto del servicio antes del iva',
      index: 'MonTotServSIVA',
    },
    {
      label: 'Monto por el uso de la plataforma',
      index: 'MonTotalporUsoPlataforma',
    },
    {
      label: 'Número de servicio',
      index: 'NumServ',
    },
    {
      label: 'Periodicidad',
      index: 'Periodicidad',
    },
    {
      label: 'Total isr retenido',
      index: 'TotalISRRetenido',
    },
    {
      label: 'Total iva retenido',
      index: 'TotalIVARetenido',
    },
    {
      label: 'Total iva trasladado',
      index: 'TotalIVATrasladado',
    },
  ];
};

export default ComplementoPlataformasTecnologicasBaseResumen;
